var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.78623 0.525391C0.565317 0.525391 0.38623 0.704477 0.38623 0.925391C0.38623 1.1463 0.565317 1.32539 0.78623 1.32539H1.29858C2.01646 1.32539 2.64647 1.80354 2.83959 2.49496L5.08182 10.5224C5.08647 10.5391 5.09211 10.5552 5.09866 10.5707L5.34967 11.4966C5.51507 12.1067 6.06878 12.5303 6.7009 12.5303H14.3658C14.9979 12.5303 15.5516 12.1067 15.717 11.4966L17.3047 5.64051C17.546 4.75039 16.8757 3.87418 15.9535 3.87418H4.05546L3.6101 2.27974C3.32041 1.24261 2.3754 0.525391 1.29858 0.525391H0.78623ZM6.1218 11.2873L4.32893 4.67418H15.9535C16.3487 4.67418 16.636 5.0497 16.5325 5.43118L14.9449 11.2873C14.874 11.5487 14.6367 11.7303 14.3658 11.7303H6.7009C6.42999 11.7303 6.19269 11.5487 6.1218 11.2873Z",
    fill: "#00C65E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06277 15.6763C9.06277 16.4622 8.42495 17.1 7.63739 17.1C6.84983 17.1 6.21201 16.4622 6.21201 15.6763C6.21201 14.8903 6.84983 14.2525 7.63739 14.2525C8.42495 14.2525 9.06277 14.8903 9.06277 15.6763Z",
    stroke: "#00C65E",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8553 15.6763C14.8553 16.4622 14.2174 17.1 13.4299 17.1C12.6423 17.1 12.0045 16.4622 12.0045 15.6763C12.0045 14.8903 12.6423 14.2525 13.4299 14.2525C14.2174 14.2525 14.8553 14.8903 14.8553 15.6763Z",
    stroke: "#00C65E",
    strokeWidth: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.4a6f5abd319f9e232146550077eccdb3.svg";
export { ForwardRef as ReactComponent };